import {initWidget} from "./initWidget";
import * as $ from "jquery";

$(function () {
    initWidget();
})
